import React, { useState, createContext, useEffect } from 'react';
import { API } from 'aws-amplify';
import { useAuth } from './Auth'
import { ProfileInteface } from '../models/ProfileInterface';
import { useApiError } from './ApiErrorProvider';
import { error } from '../constants/bindings';

const ProfileContext = createContext({ 
  loading: true, 
  profile: {} as ProfileInteface,
  getProfile: () => {}
});

export const ProfileProvider = (props) => {
  const {user} = useAuth();
  const {setErrorCode} = useApiError();
  const [profile, setProfile] = useState({} as ProfileInteface);
  const [loading, setLoading] = useState(true as boolean);

  useEffect(() => {
    if (!user) {
      return;
    }
    getProfile();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])


  const getProfile = async () => {
    if (!user) {
      return;
    }
    setLoading(true);
    try {
      const profileData = await API.get('crewlife', `/profile/retrieve`,{});
      
      if(profileData?.Error){        
        setErrorCode(error.ERR_5012);
      }else{
        setProfile({ ...profileData });
        setLoading(false);
      }      
      return profileData;
    } catch (e:any) {
      if( e.response?.status) { setErrorCode(e.response?.status); }
      else { setErrorCode(error.DEFAULT); }
      setLoading(false);
    }
  }

  return (
    <ProfileContext.Provider value={{ profile, loading, getProfile }} >
      {props.children}
    </ProfileContext.Provider>
  );
}

export const useProfile = () => {
  const context = React.useContext(ProfileContext);
  return context;
}
